"use client";
import "@/src/styles/Home.css";
import GoogleLoginButton from "@/src/components/Buttons/GoogleLoginButton";

const wordsIcon = "/images/words.png";
const words2Icon = "/images/words_2.png";
const novelsIcon = "/images/origami.png";
const securityIcon = "/images/bird.png";
const ownershipIcon = "/images/king.png";
const trustedDiary = "/images/diary.png";

export function SectionThree() {
  return (
    <div className="relative flex h-full w-full flex-col items-start justify-between bg-[#d56f5e] p-4 lg:flex-row lg:p-10">
      <img src="/images/wave.png" alt="decorative wave pattern" className="absolute bottom-0 left-0 w-[50%] object-contain" />
      <div className="relative w-full p-3 pt-10 lg:w-[40%] lg:p-5 lg:pt-20">
        <h2 className="mb-4 w-full font-questrial text-3xl font-bold leading-tight text-black lg:text-5xl">
          Hit play, watch genius unfold.
        </h2>
        <h3 className="w-full font-questrial text-3xl font-light leading-tight text-black lg:text-5xl">
          Explore the tools that ink your imagination into art.
        </h3>
      </div>
      <iframe
        className="my-10 w-full rounded-lg shadow-red-large lg:my-20 lg:w-[60%]"
        style={{ maxHeight: "700px", aspectRatio: "16/9", border: "none" }}
        src="https://www.youtube.com/embed/BL4QaPuvmsI?autoplay=1&mute=1&loop=1&playlist=BL4QaPuvmsI&controls=1&rel=0&modestbranding=1"
        title="Quarkle Demo Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}

export function SectionFour() {
  return (
    <div className="Home-Page-Four flex-col p-6 font-questrial font-bold lg:p-20">
      <div className="mb-12 text-center lg:ml-3 lg:text-left">
        <h2 className="mb-4 font-questrial text-4xl font-bold text-[#070722] lg:text-5xl">
          Chapter One: World Domination.
        </h2>
        <p className="font-questrial text-3xl font-light lg:w-[60%] lg:text-5xl">
          Okay maybe not, but these numbers are pretty spectacular.
        </p>
      </div>
      <div className="flex flex-col gap-6 md:flex-row md:justify-evenly">
        <div className="Show-Off-Container w-full border-2 border-black bg-white px-6 lg:px-20">
          <img className="h-16 w-16 lg:h-24 lg:w-24" src={wordsIcon} alt="words" />
          <span className="Show-Off-Title">40,000+</span>
          <span className="Show-Off-Subtitle">Happy Writers</span>
        </div>
        <div className="Show-Off-Container w-full border-2 border-black bg-white px-6 lg:px-20">
          <img className="h-16 lg:h-auto" id="Novel-Icon" src={novelsIcon} alt="novels" />
          <span className="Show-Off-Title">100,000+</span>
          <span className="Show-Off-Subtitle">Books Crafted</span>
        </div>
        <div className="Show-Off-Container w-full border-2 border-black bg-white px-6 lg:px-20">
          <img className="h-16 w-20 lg:h-24 lg:w-28" src={words2Icon} alt="words" />
          <span className="Show-Off-Title">1 Billion+</span>
          <span className="Show-Off-Subtitle">Words Written</span>
        </div>
      </div>
    </div>
  );
}

export function SectionFive() {
  return (
    <div className="relative flex w-full flex-col items-center bg-[#c8fcea] px-4 py-20">
      <img src="/images/boing.png" alt="decorative pattern" className="absolute right-0 top-0 w-[30%] object-contain" />
      <div className="w-9/12 self-center text-start lg:ml-24 lg:self-start">
        <h2 className="mb-4 w-full font-questrial text-3xl font-bold leading-tight text-black lg:text-5xl">
          Your Stories, Safely Tucked Away
        </h2>
        <p className="w-[85%] font-questrial text-3xl font-light leading-tight text-black lg:text-5xl">
          Craft with Confidence as we keep your creation private and secure.
        </p>
      </div>
      <div className="mt-8 flex flex-col items-center justify-center font-questrial text-[#14142d] lg:flex-row lg:justify-around">
        <div className="m-2 flex max-w-sm flex-col items-center border-2 border-black bg-[#f1ecff] p-4 shadow-md dark:bg-[#fffffc] lg:w-[32rem]">
          <img className="h-24 w-24" src={trustedDiary} alt="Security" />
          <h2 className="text-xl font-bold">Just Between Us</h2>
          <p className="text-center text-lg">
            Think of us as your trusty diary. Your manuscripts are your private stories, and we’re here to keep them that way.
          </p>
        </div>
        <div className="m-2 flex max-w-sm flex-col items-center border-2 border-black bg-[#f1ecff] p-4 shadow-md dark:bg-[#fffffc] lg:w-[32rem]">
          <img className="h-24 w-24" src={securityIcon} alt="Security" />
          <h2 className="text-xl font-bold">Safe Travels for Your Words</h2>
          <p className="text-center text-lg">
            Your words are snugly wrapped in encryption as they journey to and from Quarkle, like secret letters!
          </p>
        </div>
        <div className="z-10 m-2 flex max-w-sm flex-col items-center border-2 border-black bg-[#f1ecff] p-4 shadow-md dark:bg-[#fffffc] lg:w-[32rem]">
          <img className="h-24 w-24" src={ownershipIcon} alt="Ownership" />
          <h2 className="text-xl font-bold">Your Work, Your Rules</h2>
          <p className="text-center text-lg">
            At Quarkle, what you create remains solely yours. We're here to help refine your work, not claim any part of it.
          </p>
        </div>
      </div>
    </div>
  );
}

export function SectionSix() {
  return (
    <div className="Home-Page-Five relative">
      <h1 className="Secondary-Header mt-20">Ready to Elevate Your Manuscript?</h1>
      <span className="w-5/6 text-center text-2xl text-[#070722] dark:text-white lg:w-3/5">
        Quarkle is an advanced AI-powered Editorial Assistant designed to revolutionize the self-publishing landscape. Our platform offers
        high-quality, efficient, and affordable developmental editing solutions, streamlining the editing process for authors worldwide.
      </span>
      <GoogleLoginButton />
      <h1 className="text-center text-3xl text-[#070722] dark:text-white lg:text-5xl">Try Quarkle For Free</h1>
    </div>
  );
}
